import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ExternalLink } from 'lucide-react';
import { getRelatedTools } from '../data/relatedToolsData';

const relatedToolsDatabase_OLD = {
  'Content Creator': [
    // Writing Tools
    { name: 'Grammarly', category: 'Writing Assistant', description: 'AI-powered writing assistant for grammar, spelling, and style improvements.', url: 'https://www.grammarly.com' },
    { name: 'Hemingway Editor', category: 'Writing Assistant', description: 'Makes your writing bold and clear by highlighting complex sentences.', url: 'https://hemingwayapp.com' },
    { name: 'QuillBot', category: 'Writing Assistant', description: 'Paraphrasing tool and grammar checker for refining your content.', url: 'https://quillbot.com' },
    // Image Tools
    { name: 'Stable Diffusion', category: 'Image Generation', description: 'Open-source AI image generator with full creative control.', url: 'https://stability.ai' },
    { name: 'Canva AI', category: 'Design', description: 'Easy-to-use design platform with AI features for graphics and visuals.', url: 'https://www.canva.com' },
    { name: 'Remove.bg', category: 'Image Editing', description: 'AI-powered background removal for photos and images.', url: 'https://www.remove.bg' },
    // Video Tools
    { name: 'Synthesia', category: 'Video Generation', description: 'Create AI videos with avatars and voiceovers without filming.', url: 'https://www.synthesia.io' },
    { name: 'Descript', category: 'Video Editing', description: 'Edit videos by editing text. AI-powered transcription and editing.', url: 'https://www.descript.com' },
    // Research
    { name: 'Otter.ai', category: 'Transcription', description: 'AI meeting notes and transcription for interviews and recordings.', url: 'https://otter.ai' },
    { name: 'Glasp', category: 'Research', description: 'Social web highlighter and note-taking tool for researchers.', url: 'https://glasp.co' },
    // Automation
    { name: 'Zapier', category: 'Automation', description: 'Connect your apps and automate workflows without code.', url: 'https://zapier.com' },
    { name: 'IFTTT', category: 'Automation', description: 'Automate tasks between apps and services.', url: 'https://ifttt.com' }
  ],
  'Freelancing': [
    // Proposal & Communication
    { name: 'Proposify', category: 'Proposals', description: 'Create beautiful proposals and close deals faster.', url: 'https://www.proposify.com' },
    { name: 'PandaDoc', category: 'Proposals', description: 'Document automation software for proposals, quotes, and contracts.', url: 'https://www.pandadoc.com' },
    { name: 'Superhuman', category: 'Email', description: 'AI-powered email client for blazingly fast communication.', url: 'https://superhuman.com' },
    // Portfolio & Branding
    { name: 'Framer', category: 'Portfolio', description: 'Build professional portfolio websites without code.', url: 'https://www.framer.com' },
    { name: 'Webflow', category: 'Portfolio', description: 'Visual web development platform for building custom sites.', url: 'https://webflow.com' },
    { name: 'Contra', category: 'Portfolio', description: 'Portfolio platform built specifically for freelancers.', url: 'https://contra.com' },
    // Project Management
    { name: 'Notion', category: 'Productivity', description: 'All-in-one workspace for notes, projects, and collaboration.', url: 'https://www.notion.so' },
    { name: 'Trello', category: 'Project Management', description: 'Visual project management with boards and cards.', url: 'https://trello.com' },
    { name: 'Asana', category: 'Project Management', description: 'Work management platform for teams and freelancers.', url: 'https://asana.com' },
    // Finance
    { name: 'FreshBooks', category: 'Invoicing', description: 'Cloud accounting software for freelancers and small businesses.', url: 'https://www.freshbooks.com' },
    { name: 'Wave', category: 'Invoicing', description: 'Free accounting software with invoicing and receipts.', url: 'https://www.waveapps.com' },
    { name: 'QuickBooks', category: 'Accounting', description: 'Comprehensive accounting software for managing finances.', url: 'https://quickbooks.intuit.com' }
  ],
  'Business Growth': [
    // Strategy & Planning
    { name: 'Miro', category: 'Collaboration', description: 'Online whiteboard for strategy sessions and brainstorming.', url: 'https://miro.com' },
    { name: 'Airtable', category: 'Database', description: 'Spreadsheet-database hybrid for organizing business data.', url: 'https://airtable.com' },
    { name: 'Monday.com', category: 'Project Management', description: 'Work OS for managing projects, workflows, and teams.', url: 'https://monday.com' },
    // Analytics & Data
    { name: 'Google Analytics', category: 'Analytics', description: 'Web analytics service for tracking and reporting website traffic.', url: 'https://analytics.google.com' },
    { name: 'Mixpanel', category: 'Analytics', description: 'Product analytics for understanding user behavior.', url: 'https://mixpanel.com' },
    { name: 'Amplitude', category: 'Analytics', description: 'Digital analytics platform for product intelligence.', url: 'https://amplitude.com' },
    // Research
    { name: 'SurveyMonkey', category: 'Research', description: 'Create surveys and analyze customer feedback.', url: 'https://www.surveymonkey.com' },
    { name: 'Typeform', category: 'Research', description: 'Create beautiful, conversational surveys and forms.', url: 'https://www.typeform.com' },
    { name: 'Hotjar', category: 'Research', description: 'Website heatmaps and user behavior analytics.', url: 'https://www.hotjar.com' },
    // Presentations
    { name: 'Pitch', category: 'Presentations', description: 'Collaborative presentation software for modern teams.', url: 'https://pitch.com' },
    { name: 'Slides', category: 'Presentations', description: 'Online presentation tool with real-time collaboration.', url: 'https://slides.com' }
  ],
  'Digital Marketing': [
    // Content Creation
    { name: 'Writesonic', category: 'Copywriting', description: 'AI writer for articles, blog posts, and marketing copy.', url: 'https://writesonic.com' },
    { name: 'Anyword', category: 'Copywriting', description: 'AI copywriting with predictive performance scores.', url: 'https://anyword.com' },
    { name: 'Rytr', category: 'Copywriting', description: 'AI writing assistant for blogs, emails, and social media.', url: 'https://rytr.me' },
    // Social Media
    { name: 'Buffer', category: 'Social Media', description: 'Schedule posts and manage multiple social media accounts.', url: 'https://buffer.com' },
    { name: 'Hootsuite', category: 'Social Media', description: 'Social media management platform for businesses.', url: 'https://www.hootsuite.com' },
    { name: 'Later', category: 'Social Media', description: 'Visual content planner for Instagram and other platforms.', url: 'https://later.com' },
    // SEO & Analytics
    { name: 'Ahrefs', category: 'SEO', description: 'All-in-one SEO toolset for backlinks, keywords, and competitors.', url: 'https://ahrefs.com' },
    { name: 'Moz', category: 'SEO', description: 'SEO software for better search rankings and visibility.', url: 'https://moz.com' },
    { name: 'Clearscope', category: 'SEO', description: 'Content optimization platform for SEO-driven content.', url: 'https://www.clearscope.io' },
    // Email Marketing
    { name: 'Mailchimp', category: 'Email Marketing', description: 'All-in-one marketing platform with email campaigns.', url: 'https://mailchimp.com' },
    { name: 'ConvertKit', category: 'Email Marketing', description: 'Email marketing for creators with automation.', url: 'https://convertkit.com' },
    { name: 'Klaviyo', category: 'Email Marketing', description: 'Email and SMS marketing platform for e-commerce.', url: 'https://www.klaviyo.com' }
  ],
  'Income Growth': [
    // Course Creation
    { name: 'Kajabi', category: 'Course Platform', description: 'All-in-one platform for creating and selling online courses.', url: 'https://kajabi.com' },
    { name: 'Thinkific', category: 'Course Platform', description: 'Create, market, and sell online courses.', url: 'https://www.thinkific.com' },
    { name: 'Podia', category: 'Course Platform', description: 'Sell courses, memberships, and digital downloads.', url: 'https://www.podia.com' },
    // Digital Products
    { name: 'Shopify', category: 'E-commerce', description: 'E-commerce platform for selling physical and digital products.', url: 'https://www.shopify.com' },
    { name: 'Etsy', category: 'Marketplace', description: 'Marketplace for handmade, vintage, and creative goods.', url: 'https://www.etsy.com' },
    { name: 'SendOwl', category: 'Digital Sales', description: 'Sell digital products and subscriptions online.', url: 'https://www.sendowl.com' },
    // Freelance Platforms
    { name: 'Upwork', category: 'Freelancing', description: 'World\'s largest freelancing platform for finding work.', url: 'https://www.upwork.com' },
    { name: 'Fiverr', category: 'Freelancing', description: 'Marketplace for freelance services starting at $5.', url: 'https://www.fiverr.com' },
    { name: 'Toptal', category: 'Freelancing', description: 'Exclusive network of top freelance talent.', url: 'https://www.toptal.com' },
    // Monetization
    { name: 'Patreon', category: 'Memberships', description: 'Membership platform for creators to earn recurring income.', url: 'https://www.patreon.com' },
    { name: 'Buy Me a Coffee', category: 'Donations', description: 'Simple way for creators to accept payments from supporters.', url: 'https://www.buymeacoffee.com' },
    { name: 'Ko-fi', category: 'Donations', description: 'Free platform for receiving donations and selling products.', url: 'https://ko-fi.com' }
  ]
};

export default function RelatedTools({ useCase }) {
  const tools = getRelatedTools(useCase);
  
  // Group tools by category
  const groupedTools = tools.reduce((acc, tool) => {
    if (!acc[tool.category]) {
      acc[tool.category] = [];
    }
    acc[tool.category].push(tool);
    return acc;
  }, {});

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl">Complementary Tools for {useCase}</CardTitle>
        <CardDescription>
          Hand-picked tools that work perfectly with your main recommendations
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-8">
          {Object.entries(groupedTools).map(([category, categoryTools]) => (
            <div key={category}>
              <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                <Badge variant="outline">{category}</Badge>
              </h3>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {categoryTools.map((tool, index) => (
                  <Card key={index} className="hover:shadow-md transition-shadow">
                    <CardContent className="pt-6 pb-6 flex flex-col h-full">
                      <div className="flex-1">
                        <h4 className="font-semibold mb-2">{tool.name}</h4>
                        <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                          {tool.description}
                        </p>
                      </div>
                      <Button 
                        variant="outline" 
                        size="sm" 
                        className="w-full gap-2 mt-auto"
                        onClick={() => window.open(tool.url, '_blank')}
                      >
                        Visit
                        <ExternalLink className="w-3 h-3" />
                      </Button>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
